module.exports = __webpack_public_path__ + "media/1.95e97c1e.mp3";